import React from 'react';
import { PageWrapper, FlexContainerRowLRPadding } from '../styled/skylab/page';
const LoginPrompt = () => (React.createElement(PageWrapper, null,
    React.createElement(FlexContainerRowLRPadding, null,
        React.createElement("h2", { className: 'pad-bottom-lg' }, "You may be redirected to log in"))));
export default LoginPrompt;
